import { render, staticRenderFns } from "./StatePreventionTotal.vue?vue&type=template&id=2f620ad7&scoped=true&"
import script from "./StatePreventionTotal.vue?vue&type=script&lang=js&"
export * from "./StatePreventionTotal.vue?vue&type=script&lang=js&"
import style0 from "./StatePreventionTotal.vue?vue&type=style&index=0&id=2f620ad7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f620ad7",
  null
  
)

export default component.exports